import useIsMobile from "@/hooks/useIsMobile";
import PageLayout from "@/screens/Layout/PageLayout";
import SearchPage from "@/screens/Search";

const Index = ({
  searchResultData = null,
  latestStoryData = null,
  latestVideoData = null,
  query = "",
}) => {
  const isMobileDevice = useIsMobile();
  return (
    <PageLayout
      latestStoryData={latestStoryData}
      latestVideoData={latestVideoData}
      isMobileDevice={isMobileDevice}
    >
      <SearchPage
        searchResultData={searchResultData}
        query={query}
        isMobileDevice={isMobileDevice}
      />
    </PageLayout>
  );
};

export const getServerSideProps = async (ctx) => {
  const { logger } = await import("@/utils/logging/log-util");
  const { query } = ctx?.params ?? "";
  try {
    // const { query } = ctx?.params;
    const { getResultByQuery } = await import("@/handlers/search");
    const { getLatestStoryVideoFeed, splitLatestStoryVideoFeed } = await import("@/handlers/content");
    const { getRedisApiKey, fetchRedisWrapper } = await import(
      "@/handlers/redisKey"
    );
    const { setPageTTL } = await import("@/utils/setPageTTL");
    const { getUnixTimeDaysAgo } = await import("@/utils/dateTimeFormat");
    const unixtime = getUnixTimeDaysAgo(15);
    //* get page from query param and subtract 1 from it , also error handle if not a number
    let page = ctx?.query?.page;
    if (isNaN(page)) {
      page = 0;
    }
    page = page ? parseInt(page) - 1 : 0;

    //* get redis api key for each api
    // let searchResultRedisKey = getRedisApiKey({
    //   masterConfigData: masterConfigData,
    //   redisPrefix: "PREFIX_REDIS_ROS",
    //   params: { api: "searchlist", query, page, display: 18 },
    // });

    // let searchResultData = await fetchRedisWrapper(searchResultRedisKey, () =>
    //   getResultByQuery({ query, page, display: 18 })
    // );
    const latestStoryVideoRedisKey = getRedisApiKey({
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "latestcontentfeed",
        page: 0,
        display: 5,
        type: "story,video",
        unixtime,
      },
    });

    // let searchResultData = await getResultByQuery({ query, page, display: 18 });

    let [searchResultData, { latestStoryData, latestVideoData }] =
      await Promise.all([
        getResultByQuery({ query, page, display: 12 }),
        fetchRedisWrapper(latestStoryVideoRedisKey, () =>
        getLatestStoryVideoFeed({
          page: 0,
          display: 5,
          unixtime,
        })
      ).then(splitLatestStoryVideoFeed),
      ]);

    // if (!searchResultData) {
    //   return {
    //     notFound: true,
    //   };
    // }

    let headerCache = searchResultData?.cache;
    setPageTTL(ctx, headerCache?.akamai_ttl);

    return {
      props: {
        searchResultData,
        latestStoryData,
        latestVideoData,
        query,
      },
    };
  } catch (error) {
    logger.error(error);
    return {
      notFound: true,
    };
  }
};

export default Index;
